import { QueryClient } from '@tanstack/react-query';
import { categorizeFirestoreError } from './firebaseErrors';

export const isRetryableNetworkError = (error: unknown): boolean =>
  categorizeFirestoreError(error) === 'network';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: 'always',
      networkMode: 'online',
      retry: (failureCount, error) =>
        failureCount < 2 && isRetryableNetworkError(error),
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
  },
});
